const SeasonsTypes = {
    GET_SEASONS_START: 'GET_SEASONS_START',
    GET_SEASONS_SUCCESS: 'GET_SEASONS_SUCCESS',
    GET_APP_SEASONS_SUCCESS: 'GET_APP_SEASONS_SUCCESS',
    GET_SEASONS_FAILED: 'GET_SEASONS_FAILED',
    SET_ACTIVE_SEASON: 'SET_ACTIVE_SEASON'
}

export default SeasonsTypes